import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import LiveHelpTwoToneIcon from "@mui/icons-material/LiveHelpTwoTone";

export default function SupportTeam(props) {
  const { status } = props;
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      {status === "Failed" || status === "Cordoned" ? (
        <React.Fragment>
          <IconButton aria-label="delete" onClick={handleClickOpen}>
            <LiveHelpTwoToneIcon style={{ color: "yellowgreen" }} />
          </IconButton>
          <span>Help</span>
        </React.Fragment>
      ) : (
        ""
      )}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title"></DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please contact the Support Team{" "}
            <strong style={{ color: "#EF5350" }}>Support@zippyops.com</strong>
          </DialogContentText>
          <br />
          <br />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
